/*
 * @Description: 
 * @Author: ywj
 * @Date: 2023-12-20 10:30:15
 * @LastEditTime: 2024-01-17 11:59:08
 * @LastEditors: ywj@originqc.com
 */
import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import counterReducer from '../features/counter/counterSlice';
import themeReducer from '../features/main/themeSlice';
import jupyterReducer from '@/features/main/jupyterSlice';
import menuListReducer from '@/features/main/menuListSlice';
import messageReducer from '@/features/main/messageSlice';
import ideReducer from '@/features/main/ideSlice';
import commomReducer from './common';
// import {qvmReducer} from '../views/quantumProgramming/redux';
import userReducer from '../features/user/userSlice'
import topoNodeArrReducer from '../features/main/topoNodeSlice';
import selectNodeNameArrReducer from '../features/main/topoSelectNameSlice';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    theme: themeReducer,
    jupyter: jupyterReducer,
    headerMenu: menuListReducer,
    message: messageReducer,
    common: commomReducer,
    user: userReducer,
    ide: ideReducer,
    topoNodeArr:topoNodeArrReducer,
    topoSelectNameArr:selectNodeNameArrReducer,
    // ...qvmReducer
  },
});

export const dispatch = store.dispatch;
export const getState = store.getState;
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
